import up from 'unpoly';

const els = new Set();
const elToOnInput = new Map();
const elToOnReset = new Map();

const autosize = (el) => {
    if (el.offsetParent === null) {
        return;
    }

    const { pageXOffset } = window;
    const { pageYOffset } = window;

    el.style.height = null;

    const min = +window.getComputedStyle(el).height.replace(/px/, '');

    el.style.height = '0';

    const style = window.getComputedStyle(el);

    const borderTop = +style.borderTopWidth.replace(/px/, '');
    const borderBottom = +style.borderBottomWidth.replace(/px/, '');

    const scroll = el.scrollHeight;

    const auto = borderTop + scroll + borderBottom;

    let height;

    if (min >= auto) {
        height = null;
    } else {
        height = `${auto}px`;
    }

    el.style.height = height;

    window.scrollTo(pageXOffset, pageYOffset);
};

const autosizeAll = () => {
    els.forEach((el) => {
        autosize(el);
    });
};

const init = (el) => {
    el.classList.add('resize-none');
    el.style.setProperty('resize', 'none');

    const onInput = () => {
        autosize(el);
    };

    elToOnInput.set(el, onInput);

    el.addEventListener('input', onInput);

    if (el.form) {
        const onReset = () => {
            setTimeout(() => {
                autosize(el);
            });
        };

        elToOnReset.set(el, onReset);

        el.form.addEventListener('reset', onReset);
    }

    autosize(el);
};

const destroy = (el) => {
    els.delete(el);

    const onEvent = elToOnInput.get(el);
    elToOnInput.delete(el);

    const onReset = elToOnReset.get(el);
    elToOnReset.delete(el);

    el.removeEventListener('input', onEvent);

    if (el.form && onReset) {
        el.form.removeEventListener('reset', onReset);
    }
};

up.compiler('textarea.js-textarea-auto-height', (el) => {
    init(el);

    return () => {
        destroy(el);
    };
});

window.addEventListener('resize', autosizeAll);
